import React from 'react';
import ABSIcon from '../ABSIcon';
import './DetailRight.less';

export interface IDetailRightProps {
  onClose: () => void;
}
 
export interface IDetailRightState {
  
}
 
class DetailRight extends React.Component<IDetailRightProps, IDetailRightState> {
  render() { 
    const { children, onClose } = this.props;
    return (
      <div className="abs-list-detail-container-right">
        <ABSIcon className="abs-list-detail-container-right-close" type="close" onClick={onClose} />
        <div className="abs-list-detail-container-right-content">{children}</div>
      </div>
    );
  }
}
 
export default DetailRight;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSListDetailContainer/DetailRight.tsx